exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotation{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}.Background{background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;width:100%;height:100%;position:absolute;top:0;left:0}.CloseBackground{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1}.CloseButton{color:#383d45;position:absolute;top:24px;right:24px;font-size:1.75rem}.FloatingBox{position:relative;z-index:2;background:#fff;padding:24px}.StaticTitle{position:absolute;width:100%;background:linear-gradient(to bottom, #fff 0%, #fff 75%, rgba(255,255,255,0) 100%);top:0;left:0;z-index:1;padding:50px}.Wrapper{display:flex;max-width:652px;border-radius:2px;box-shadow:0 1px 3px 0 rgba(0,0,0,0.12),0 5px 15px 0 rgba(0,0,0,0.08);background-color:#ffffff;display:flex;min-width:30%}\n", ""]);

// exports
exports.locals = {
	"Background": "Background",
	"CloseBackground": "CloseBackground",
	"CloseButton": "CloseButton",
	"FloatingBox": "FloatingBox",
	"StaticTitle": "StaticTitle",
	"Wrapper": "Wrapper",
	"rotation": "rotation"
};